import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { IOrderProduct } from '@models/orders/order-product';
import { HTTPResponse, APP_CONFIG } from '@mavles/shared';
import { OrderElementService } from './order-element.service';

@Injectable({
  providedIn: 'root'
})
export class OrderProductApiService {
  private http = inject(HttpClient);
  private appConfig = inject(APP_CONFIG);
  private elementService = inject(OrderElementService);
  
  private readonly orderProductAPI = this.appConfig.apiUrl + 'accounts/products/';

  public products: IOrderProduct[] = [];
  private product$ = new BehaviorSubject<IOrderProduct[]>([]);
  private refreshStatus!: Subscription;

  constructor() {
    this.refresh();
  }

  refresh() {
    this.refreshStatus = this.getAllProducts().subscribe(p => {
      this.products = p.data;
      this.product$.next(p.data);
    });
  }

  changes$(): Observable<IOrderProduct[]> {
    return this.product$.asObservable();
  }

  save(product: IOrderProduct): Observable<HTTPResponse<IOrderProduct>> {
    if (product.product_id) {
      return this.http.post<HTTPResponse<IOrderProduct>>(this.orderProductAPI + 'update', product);
    }
    return this.http.post<HTTPResponse<IOrderProduct>>(this.orderProductAPI + 'add', product);
  }

  delete(id: number): Observable<any> {
    return this.http.delete(this.orderProductAPI + 'delete/' + id);
  }

  getByID(id: number): Promise<IOrderProduct | undefined> {
    return new Promise((resolve) => {
       if (this.refreshStatus?.closed) {
          resolve(this.products.find(p => p.product_id == id));
       } else {
        const sub$ = this.changes$();
        sub$.subscribe(res => {
          if (res.length > 0) {
            resolve(this.products.find(p => p.product_id == id));
          }
        });
       }
    });
  }

  getLineProducts(): Promise<IOrderProduct[]> {
    return new Promise((resolve) => {
      if (this.refreshStatus?.closed) {
         resolve(this.getProductByElement());
      } else {
       const sub$ = this.changes$();
       sub$.subscribe(res => {
         if (res.length > 0) {
          resolve(this.getProductByElement());
         }
       });
      }
   });
  }

  public getProductByElement(): IOrderProduct[] {
    const elem = this.elementService.getCurrentElement();
    return this.products.filter(p => p.product_element_id == elem?.element_id);
  }

  private getAllProducts(): Observable<any> {
    return this.http.get(this.orderProductAPI + 'get-all');
  }
}
